import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import uniq from 'utils/uniq';
import { Form } from 'components/base';

import { Panel, Typography } from '../../components/base';
import { Card } from '../../components/rich';

const DesignSelect = props => {
  const [activeCategory, setActiveCategory] = useState();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const items = [];
    props.items.forEach(item => {
      if ('category' in item) {
        items.push(item.category);
      }
    });

    setCategories(uniq(items));

    const activeItem = props.items.find(i => i.key === props.active);
    setActiveCategory(activeItem ? activeItem.category : null);
  }, [props.items, props.active]);

  const handleOnItemClick = (e, key) => {
    e.preventDefault();

    props.onChange(key);
  };

  let items;
  if (categories.length > 1) {
    items = props.items.filter(i => i.category === activeCategory);
  } else {
    items = props.items;
  }

  return (
    <>
      {categories.length > 1 && (
        <Form.Select
          value={activeCategory}
          onChange={e => setActiveCategory(e.target.value)}
          className="mb-1 mw-480 mx-auto"
        >
          {categories.map(category => (
            <Form.SelectOption key={category} value={category}>
              {category === '' ? 'Other' : category}
            </Form.SelectOption>
          ))}
        </Form.Select>
      )}

      <Panel borderColor="orange" className={props.className}>
        <Typography.Heading size={2} mb={3}>
          {props.title}
        </Typography.Heading>
        {items.map(item => (
          <Card
            minHeight="72px"
            key={item.key}
            onClick={e => handleOnItemClick(e, item.key)}
            mt={1}
            p={1}
            selected={item.key === props.active}
          >
            {item.icon && <Card.Image src={item.icon} active={props.active === item.key} />}
            {item.preview}
            {(item.title || item.subTitle) && (
              <Card.Data>
                {item.title && <Typography.Heading size={4}>{item.title}</Typography.Heading>}
                {item.subTitle && <Typography.Text size={4}>{item.subTitle}</Typography.Text>}
              </Card.Data>
            )}
          </Card>
        ))}
      </Panel>
    </>
  );
};

DesignSelect.propTypes = {
  title: PropTypes.string,
  active: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.string,
      category: PropTypes.string,
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  className: PropTypes.string,
};

DesignSelect.defaultProps = {
  items: [],
};

export default DesignSelect;
